module.exports = __webpack_public_path__ + "static/media/metamask.4438fc27.png";